import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface QuejaPayload {
  id_colaborador: number;
  tipo: string;
  fecha_queja: string; // formato YYYY-MM-DD
  origen: string;
  motivo: string;
  respuesta?: string | null;
  fecha_respuesta?: string | null;
  estado_gestion: string;
  documento_id?: number | null;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface Queja {
  id?: number;
  id_colaborador: number;
  tipo: string;
  fecha_queja: string;
  origen: string;
  motivo: string;
  respuesta?: string | null;
  fecha_respuesta?: string | null;
  estado_gestion: string;
  documento_id?: number | null;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
  // Datos anidados que el backend incluye vía joins/includes, usados en los templates de listado y seguimiento
  ColaboradorQuejaData?: {
    nombreCompleto?: string;
    [key: string]: any;
  };
  TipoQuejaData?: {
    descripcion?: string;
    [key: string]: any;
  };
  OrigenQuejaData?: {
    descripcion?: string;
    [key: string]: any;
  };
  EstadoGestionData?: {
    descripcion?: string;
    [key: string]: any;
  };
}

export interface QuejaResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class QuejasService {
  private readonly apiUrl = `${environment.apiUrl}/api/quejas`;

  constructor(private http: HttpClient) {}

  // Listar todas las quejas
  getAll(): Observable<Queja[]> {
    return this.http.get<Queja[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<Queja> {
    return this.http.get<Queja>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nueva queja
  create(payload: QuejaPayload): Observable<QuejaResponse> {
    return this.http.post<QuejaResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar queja
  update(id: number, payload: Partial<QuejaPayload>): Observable<QuejaResponse> {
    return this.http.put<QuejaResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar queja (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar queja
  inactivar(id: number): Observable<QuejaResponse> {
    return this.http.put<QuejaResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar queja
  activar(id: number): Observable<QuejaResponse> {
    return this.http.put<QuejaResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}